import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const deleteShotClass = (shotclassId) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.MANAGE.DELETE_SHOTCLASS(shotclassId)
  );
};

export default deleteShotClass;
